import { TagPicker, Label } from "../../fluent";
import { isNullOrEmpty } from "../helpers/string-helper";
import React from "react";
export const KeyWordField = (props) => {
    const keywords = (props.keywords || []).map(o => ({ key: o, name: o }));
    const selectedItems = (props.selectedItems || []).map(o => ({ key: o, name: o }));
    return React.createElement(React.Fragment, null,
        React.createElement(Label, null, props.label),
        React.createElement(TagPicker, { onResolveSuggestions: (filterText, currentTags = []) => {
                // Excluir del listado los tags que ya han sido seleccionados
                let tags = keywords.filter(o => currentTags.findIndex(p => o.key == p.name) < 0);
                // Si el texto que el usuario esta escribiendo no está, se agrega entonces como una opción más
                if (keywords.findIndex(o => o.name.trim().toLowerCase() == filterText.trim().toLowerCase())) {
                    tags.push({ key: filterText, name: filterText });
                }
                if (isNullOrEmpty(filterText)) {
                    return tags;
                }
                // Filtrar items que coincidan con el texto
                tags = tags.filter(tag => tag.name.toLowerCase().includes(filterText.toLowerCase()));
                return tags;
            }, getTextFromItem: (item) => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.documentTitleProps) === null || _a === void 0 ? void 0 : _a.title) || ''; }, pickerSuggestionsProps: {
                suggestionsHeaderText: 'Palabras clave sugeridas',
                noResultsFoundText: 'Presione la tecla Enter para crear'
            }, itemLimit: 10, onChange: (items = []) => props.onChanged(items.map(o => o.name)), selectedItems: selectedItems, disabled: props.disabled }));
};
